import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { NOTES_QUERY_KEY } from "./useNotes";

type NoteResponse = components["schemas"]["NoteResponse"];

export type RestoreNoteVariables = {
  noteId: string;
};

export function useRestoreNote() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<NoteResponse, Error, RestoreNoteVariables>({
    mutationFn: async ({ noteId }) => {
      const { data, error } = await client.POST(
        "/api/notes/{note_id}/restore",
        { params: { path: { note_id: noteId } } },
      );
      if (error !== undefined) {
        throw new Error(`Failed to restore note ${noteId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: NOTES_QUERY_KEY });
    },
  });
}
